@if (state === 'new') {
  <div class="changelog-hint" data-cy="changelog-not-saved">
    <i aria-hidden="true" class="icon-info"></i>
    <span>{{ 'specificWindow.changeLog.notSaved' | translate }}</span>
  </div>
} @else {
  <div class="infos" [class.is-loading]="state === 'loading'">
    @if (!isView) {
      <div class="info" data-cy="changelog-created">
        <i aria-hidden="true" class="info-icon icon-user"></i>
        <div class="info-text">
          <label>{{ 'editView.createdBy' | translate }}</label>
          <span class="info-value">{{ created?.by || '-' }}</span>
          @if (created?.absolute) {
            <span class="info-date" tooltipPosition="bottom" [pTooltip]="created.absolute">
              {{ created.relative }}
            </span>
          }
        </div>
      @if (created) {
        <button
          class="changelog-icon-btn"
          type="button"
          [attr.data-cy]="'changelog-copy-created'"
          [attr.aria-label]="'editView.copyToClipBoard' | translate"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ 'editView.copyToClipBoard' | translate }}"
          (click)="copyStamp(created, 'created')">
          <i aria-hidden="true" [class]="copiedKey === 'created' ? 'icon-check' : 'icon-copy'"></i>
        </button>
      }
      </div>
      <div class="info" data-cy="changelog-updated">
        <i aria-hidden="true" class="info-icon icon-edit-pencil"></i>
        <div class="info-text">
          <label>{{ 'editView.updatedBy' | translate }}</label>
          <span class="info-value">{{ updated?.by || '-' }}</span>
          @if (updated?.absolute) {
            <span class="info-date" tooltipPosition="bottom" [pTooltip]="updated.absolute">
              {{ updated.relative }}
            </span>
          }
        </div>
      @if (updated) {
        <button
          class="changelog-icon-btn"
          type="button"
          [attr.data-cy]="'changelog-copy-updated'"
          [attr.aria-label]="'editView.copyToClipBoard' | translate"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ 'editView.copyToClipBoard' | translate }}"
          (click)="copyStamp(updated, 'updated')">
          <i aria-hidden="true" [class]="copiedKey === 'updated' ? 'icon-check' : 'icon-copy'"></i>
        </button>
      }
      </div>
    }
    <div class="info" data-cy="changelog-id">
      <i aria-hidden="true" class="info-icon icon-hashtag"></i>
      <div class="info-text">
        <label>ID ({{ auditsInfo.tableName }})</label>
        <span class="info-value info-id">{{ auditsInfo.id_txt }}</span>
      </div>
      @if (auditsInfo.id_txt !== '') {
        <button
          class="changelog-icon-btn"
          type="button"
          [attr.aria-label]="'editView.copyToClipBoard' | translate"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ 'editView.copyToClipBoard' | translate }}"
          (click)="copyToClipBoard(auditsInfo.id_txt)">
          <i aria-hidden="true" class="icon-copy"></i>
        </button>
      }
    </div>
  </div>

  @if (isCopiedToClipBoard) {
    <div class="changelog-copied-to-clipboard" role="status">
      {{ (copiedKey ? 'specificWindow.changeLog.valueCopied' : 'editView.copyToClipBoardMsg') | translate }}
    </div>
  }

  @if (state === 'error') {
    <div class="changelog-hint changelog-error" role="alert">
      <i aria-hidden="true" class="icon-triangle-exclamation"></i>
      <span>{{ 'specificWindow.changeLog.loadError' | translate }}</span>
    </div>
  } @else if (state === 'loading') {
    <div class="changelog-hint" aria-busy="true">
      <i aria-hidden="true" class="icon-spinner fa-spin"></i>
      <span>{{ 'specificWindow.changeLog.loading' | translate }}</span>
    </div>
  } @else if (isLogged) {
    @if (rows.length === 0) {
      <div class="changelog-hint" data-cy="changelog-empty">
        <i aria-hidden="true" class="icon-hours"></i>
        <span>{{ 'specificWindow.changeLog.empty' | translate }}</span>
      </div>
    } @else {
      <div class="table-wrapper">
        <table class="changelog-table" data-cy="changelog-table">
          <thead>
            <tr>
              <th scope="col">{{ 'specificWindow.changeLog.headerCols.columnName' | translate }}</th>
              <th scope="col">{{ 'specificWindow.changeLog.headerCols.newValue' | translate }}</th>
              <th scope="col">{{ 'specificWindow.changeLog.headerCols.oldValue' | translate }}</th>
              <th scope="col">{{ 'specificWindow.changeLog.headerCols.updated' | translate }}</th>
              <th scope="col">{{ 'specificWindow.changeLog.headerCols.updatedBy' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track $index) {
              <tr>
                <td class="col-name">{{ row.columnName }}</td>
                <td class="col-value" [title]="row.newValue ?? ''" (dblclick)="copyValue(row.newValue, $index + '-new')">
                  @if (row.newValue === null || row.newValue === undefined || row.newValue === '') {
                    <span class="empty-value">&#8212;</span>
                  } @else {
                    <span class="value-text">{{ row.newValue }}</span>
                    <button
                      type="button"
                      class="value-copy"
                      [attr.data-cy]="'changelog-copy-new'"
                      [attr.aria-label]="'specificWindow.changeLog.copyValue' | translate"
                      [title]="'specificWindow.changeLog.copyValue' | translate"
                      (click)="copyValue(row.newValue, $index + '-new')">
                      <i aria-hidden="true" [class]="copiedKey === $index + '-new' ? 'icon-check' : 'icon-copy'"></i>
                    </button>
                  }
                </td>
                <td class="col-value col-old" [title]="row.oldValue ?? ''" (dblclick)="copyValue(row.oldValue, $index + '-old')">
                  @if (row.oldValue === null || row.oldValue === undefined || row.oldValue === '') {
                    <span class="empty-value">&#8212;</span>
                  } @else {
                    <span class="value-text">{{ row.oldValue }}</span>
                    <button
                      type="button"
                      class="value-copy"
                      [attr.data-cy]="'changelog-copy-old'"
                      [attr.aria-label]="'specificWindow.changeLog.copyValue' | translate"
                      [title]="'specificWindow.changeLog.copyValue' | translate"
                      (click)="copyValue(row.oldValue, $index + '-old')">
                      <i aria-hidden="true" [class]="copiedKey === $index + '-old' ? 'icon-check' : 'icon-copy'"></i>
                    </button>
                  }
                </td>
                <td class="col-date" [title]="relativeDate(row.updated)">{{ dateFormater(row.updated) }}</td>
                <td class="col-user">{{ row.updatedBy }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      @if (hasMore) {
        <div class="changelog-more">
          <button
            class="p-button p-button-secondary"
            data-cy="changelog-load-more"
            icon="icon-open"
            pButton
            type="button"
            [disabled]="loadingMore"
            [label]="'specificWindow.changeLog.loadMore' | translate"
            [loading]="loadingMore"
            (click)="loadMore()"></button>
        </div>
      }
    }
  } @else if (!isView) {
    <div class="changelog-hint" data-cy="changelog-not-logged">
      <i aria-hidden="true" class="icon-info"></i>
      <span>{{ 'specificWindow.changeLog.notLogged' | translate }}</span>
    </div>
  }
}
